import { Component, Input } from '@angular/core';
import { AgentDto, AuditSessionDto, ResultListDto } from '../../../../service/dto';
import { HttpAuditService } from '../../../../service/http-audit.service';
import { OnTableChange, TableColumn } from '../../../../components/table/table.component';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-agent-audit-sessions',
	standalone: false,
	templateUrl: './agent-audit-sessions.component.html',
	styleUrl: './agent-audit-sessions.component.scss'
})
export class AgentAuditSessionsComponent {
	_agent!: AgentDto;
	results!: ResultListDto<AuditSessionDto>;
	loading = false;
	columnRef: TableColumn[] = [
		{ "title": "Session ID", "property": "id" },
		{ "title": "Logged in", "property": "createdAt" },
		{ "title": "Last seen", "property": "lastAccessedAt" },
		{ "title": "Has access until", "property": "lastAccessUntil" },
		{ "title": "Session age", "property": "activeDurationLabel" },
		{ "title": "Backend request count ", "property": "requestCount" }
	];

	constructor(private service: HttpAuditService) {

	}

	@Input('agent')
	set agent(input: AgentDto) {
		this._agent = input;
		this.loading = true;
		this.service.getAgentsSessionHistory(this._agent.id, 0, 50)
		.pipe(finalize(()=> this.loading=false))
		.subscribe(results => {
			this.results = results;
		})
	}

	get agent(): AgentDto {
		return this._agent;
	}	

	trackByHashCode(index: number, item: AuditSessionDto): any {
		return item.hashCode;
	}

	doFetchResults(input: OnTableChange) {
		this.loading = true;
		this.service.getAgentsSessionHistory(this._agent.id, input.pageIndex, input.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.results = result;
			});
	}
}

